import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import './index.css';
import App from './App';
import theme from './theme';
import reportWebVitals from './reportWebVitals';
// Side-effect import: registers the `beforeinstallprompt` listener before React
// mounts, so the "Install EduMIS" popup can offer the native install prompt.
import './utils/pwaInstall';

// The app runs on the single (light) theme. Light/dark is a Landing-page-only
// feature — see pages/Landing.js, which wraps itself in its own ThemeProvider.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// Register the minimal service worker (production only) so the app is installable
// and the "Install EduMIS" prompt can fire. It caches nothing — see public/service-worker.js.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/service-worker.js`)
      .catch(() => { /* installability is best-effort; ignore registration errors */ });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
